import React, { useEffect } from 'react';
import { HeatmapProps } from './Heatmap.interface';
import L from 'leaflet';
import 'leaflet.heat';

export function Heatmap({ data, name }: HeatmapProps ) {
    const max = data[0].count;
    const points = data.map((el: {lat: any, lng: any, count: number}) => {
        return [parseFloat(el.lat), parseFloat(el.lng), el.count];
    })
    useEffect(() => {
        var map = L.map(`${name}`).setView([0, 0], 1);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            minZoom: 1,
            maxZoom: 10
        }).addTo(map);
        L.heatLayer(points, { 
            radius: 15,
            blur: 10,
            minOpacity: 0.3,
            max: max,
            maxZoom: 10,
            gradient: {
                0.0: '#020024',
                0.2: '#60e5ff',
                0.4: '#41f554',
                0.6: '#d8eb2e',
                0.8: '#e2b87f',
                1.0: '#ff0000',
            }
        }).addTo(map);
    }, []);
    return <div id={`${name}`} style={{ height: "450px", marginTop: " 16px" }}></div>;
}
